import type { ClarifyCatalogItem } from '@/domain/providerConfig';

/** The label keys that tell Clarify items apart at a site: the basin, the source, the plan. */
const TELLING_KEYS = ['area', 'data-source', 'plan'];

function keyOf(label: string): string {
    return label.split(':')[0].trim();
}

/**
 * Each item's labels as one short line, for telling items with the same name apart. The
 * telling labels (area, data-source, plan) where an item has any, else all of its labels;
 * where two items with the same name still read the same, all of their labels.
 */
export function catalogLabelLines(items: readonly ClarifyCatalogItem[]): Map<string, string> {
    const chosen = new Map<string, string[]>();
    for (const item of items) {
        const telling = item.labels.filter((label) => TELLING_KEYS.includes(keyOf(label)));
        chosen.set(item.id, telling.length > 0 ? telling : item.labels);
    }
    const seen = new Map<string, number>();
    for (const item of items) {
        const key = `${item.name}\u0000${(chosen.get(item.id) ?? []).join('\u0000')}`;
        seen.set(key, (seen.get(key) ?? 0) + 1);
    }
    const lines = new Map<string, string>();
    for (const item of items) {
        const labels = chosen.get(item.id) ?? [];
        const key = `${item.name}\u0000${labels.join('\u0000')}`;
        const shown = (seen.get(key) ?? 0) > 1 ? item.labels : labels;
        lines.set(item.id, shown.join(' · '));
    }
    return lines;
}
